/**
 * Wait for the DOM to be ready before executing the callback.
 */
export const onReady = (callback: () => void) => {
    if (document.readyState !== 'loading') {
        callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
};
